<template>
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <circle cx="8" cy="8" r="8" fill="#FFEBEB" />
    <path
      d="M5 4.11133H12.5047L10.837 6.75263L12.5047 9.39393H5V4.11133Z"
      fill="#DA4E4E"
    />
    <path d="M5.37012 3L5.37012 13.37" stroke="#333333" />
  </svg>
</template>

<script>
export default {
  name: "flag-icon",
};
</script>
